import DataTable from "components/data-table/data-table";
import { TableColumn } from "components/table/table";
import { currencyFormat } from "core/utils";
import { ObjectIndex } from "types";
import { PagoDomiciliadoRespuesta } from "../types/pagos.types";

const columns: TableColumn[] = [
	{ key: "concepto", title: "Concepto de Pago", tdStyle: { width: 320 } },
	{ key: "importe", title: "Importe", tdStyle: { width: 180 } },
	{ key: "", title: "", tdStyle: { width: "60%" } }
];

type PagosDomiciliadosTableProps = { registros: PagoDomiciliadoRespuesta[]; };

const mostrarAcciones = (column: TableColumn, registro: PagoDomiciliadoRespuesta & ObjectIndex) => {
	if (column.key === "importe") {
		return currencyFormat(registro[column.key]);
	}

	return registro[column.key];
};

const PagosDomiciliadosTable = ({ registros }: PagosDomiciliadosTableProps) => {
	return (
		<DataTable columns={columns} items={registros} onRenderItem={mostrarAcciones} />
	);
};

export default PagosDomiciliadosTable;